/**
 * Created by Alex Aguilar on 3/24/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('stretchService',stretchService);

    stretchService.$inject = ['$http', 'CONFIG','messageService'];

    function stretchService($http, CONFIG, messageService){

        var urlBase = CONFIG.API_URL + '/flight-control/api/segments';

        /*if(CONFIG.SERVER == 'server'){
            urlBase = CONFIG.API_URL + '/flight-control/api/stretches';
        }*/

        var service = {
            getStretches: getStretches,
            getStretch: getStretch,
            saveStretch: saveStretch,
            updateStretch: updateStretch,
            deleteStretch: deleteStretch
        };

        return service;

        function getStretches(){
            return $http.get(urlBase + '/list')
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findAllError('');
                });
        }

        function getStretch(originId, destinyId){
            return $http.get(urlBase + "/" + originId + "_" + destinyId)
                .then(function(response){
                    return response;
                }, function(){
                    //messageService.findAllError('');
                });
        }

        function saveStretch(stretch){
            return $http.post(urlBase, stretch)
                .then(function(){
                    messageService.register('stretchList');
                }, function(){
                    messageService.registerError('');
                });
        }

        function updateStretch(stretch){
            return $http.put(urlBase + "/" + stretch.originAirport.rId + "/destiny/" +
                    stretch.destinyAirport.rId, stretch)
                .then(function(){
                    messageService.registerUpdate('stretchList');
                }, function(){
                    messageService.registerUpdateError('');
                });
        }

        function deleteStretch(originId, destinyId){
            return $http.delete(urlBase + "/" + originId + "/destiny/" + destinyId)
                .then(function(){
                    messageService.registerDelete('stretchList');
                }, function(){
                    messageService.registerEnableError('');
                })
        }
    }
})();
